import React, { Component } from "react";

import {
  CButton,
  CTextarea,
  CInput,
  CSpinner,
  CModal,
  CModalFooter,
  CModalBody,
  CModalHeader
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import URL from "../../config/api";
import axios from "../../config/axios";

import "react-bootstrap-table/dist//react-bootstrap-table-all.min.css";

class ForumModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "",
      description: "",
      loading: false
    };
  }

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  insertForum() {
    if (this.state.title === "") {
      toastr.error("Atenção", "Digite um título para a discussão.");
    } else if (this.state.description === "") {
      toastr.error("Atenção", "Digite uma descrição para a discussão.");
    } else {
      this.setState({ loading: true });

      const id = this.props.room;
      axios
        .post(
          `${URL.api}communication/forum/insert`,
          {
            title: this.state.title,
            description: this.state.description,
            room_id: id,
            user_id: this.props.user.user.id
          },
          { headers: { Authorization: `Bearer ${this.props.user.token}` } }
        )
        .then(
          resp => {
            this.setState({ title: "", description: "", loading: false });
            this.props.onClose(resp.data.data);
          },
          error => {
            this.error(error.response.statusText);
          }
        );
    }
  }

  render() {
    return (
      <CModal
        size="lg"
        centered
        show={this.props.show}
        onClose={() => this.props.onClose()}
        closeOnBackdrop={false}
      >
        <CModalHeader closeButton>
          <CInput
            type="text"
            value={this.state.title}
            onChange={e => this.setState({ title: e.target.value })}
            placeholder="Digite o título da discussão"
            className="border-0 p-0 h-auto shadow-none"
          />
        </CModalHeader>
        <CModalBody
          className="p-0"
          style={{ maxHeight: "600px", overflow: "auto" }}
        >
          <CTextarea
            type="text"
            value={this.state.description}
            onChange={e => this.setState({ description: e.target.value })}
            placeholder="Digite a descrição da discussão"
            rows={6}
            style={{ resize: "none" }}
            className="border-0 p-3 shadow-none"
          />
        </CModalBody>
        <CModalFooter>
          <CButton
            color="primary"
            className="d-flex justify-content-center align-items-center"
            onClick={() => this.insertForum()}
          >
            <span className={this.state.loading ? "invisible" : ""}>Criar</span>
            {this.state.loading && (
              <CSpinner
                size="sm"
                color="white"
                style={{ position: "absolute" }}
              />
            )}
          </CButton>{" "}
          <CButton color="secondary" onClick={() => this.props.onClose()}>
            Cancelar
          </CButton>
        </CModalFooter>
      </CModal>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ForumModal);
